module.exports = __webpack_public_path__ + "img/thsr.504e3a83.png";